import React from "react";
import styled, { css } from "react-emotion";

const Accordian = styled("div")`
  width: 100%;
  overflow: hidden;

  @media (min-width: 767px) {
    height: 320px;
  }
`;

const Item = styled("li")`
  @media (max-width: 767px) {
    height:150px;
    position: relative;
  }

  @media (min-width: 767px) {
    position: relative;
    display: block;
    width: 160px;
    float: left;
    border-left: 1px solid #888;
    max-height: 320px;

    box-shadow: 0 0 25px 10px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 0 0 25px 10px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 0 0 25px 10px rgba(0, 0, 0, 0.5);

    transition: all 0.5s;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
  }

  @media (max-width: 978px) and (min-width: 768px) {
    width: 110px;
  }
`;

const ItemList = styled("ul")`
  padding-left: 0;
  overflow: hidden;
  width: 2000px;

  @media (min-width: 767px) {
    &:hover li {
      width: 74px;
    }
  
    & li:hover {
      width: 640px;
    }
  }
  
  @media (max-width: 1200px) and (min-width: 992px) {
    & li:hover {
      width: 560px;
    }
  }

  @media (max-width: 978px) and (min-width: 768px) {
    & li:hover {
      width: 320px;
    }
  }
`;

const Title = styled("div")`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;

  @media (min-width: 1201px) {
    width: 640px;
  }

  @media (min-width: 992px) and (max-width: 1200px) {
    width: 560px;
  }

  @media (max-width: 978px) and (min-width: 768px) {
    width: 320px;
  }  
`;

const TitleLink = styled("a")`
  display: block;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
  padding: 20px;
  font-size: 16px;
  &:hover {
    text-decoration: none;
    color: #fff;
  }
`;

export default class Accordeon extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Accordian>
        <ItemList>
          <Item>
            <Title>
              <TitleLink href="#">{this.props.title1}</TitleLink>
            </Title>
            <a href="">
              <img
                className={css({
                  display: "block"
                })}
                src={this.props.image1}
              />
            </a>
          </Item>
          <Item>
            <Title>
              <TitleLink href="#">{this.props.title2}</TitleLink>
            </Title>
            <a href="">
              <img
                className={css({
                  display: "block"
                })}
                src={this.props.image2}
              />
            </a>
          </Item>
          <Item>
            <Title>
              <TitleLink href="#">{this.props.title3}</TitleLink>
            </Title>
            <a href="#">
              <img
                className={css({
                  display: "block"
                })}
                src={this.props.image3}
              />
            </a>
          </Item>
          <Item>
            <Title>
              <TitleLink href="#">{this.props.title4}</TitleLink>
            </Title>
            <a href="#">
              <img
                className={css({
                  display: "block"
                })}
                src={this.props.image4}
              />
            </a>
          </Item>
          <Item>
            <Title>
              <TitleLink href="#">{this.props.title5}</TitleLink>
            </Title>
            <a href="#">
              <img
                className={css({
                  display: "block"
                })}
                src={this.props.image5}
              />
            </a>
          </Item>
          <Item>
            <Title>
              <TitleLink href="#">{this.props.title6}</TitleLink>
            </Title>
            <a href="#">
              <img
                className={css({
                  display: "block"
                })}
                src={this.props.image6}
              />
            </a>
          </Item>
        </ItemList>
      </Accordian>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Accordeon.js